function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimelineBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 64,
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "rect462",
    style: {
      fill: "rgba(180, 180, 180, 0.5)",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "M 8 0 A 8 8 0 0 0 0 8 L 0 40 A 8 8 0 0 0 8 48 A 8 8 0 0 0 16 40 L 16 8 A 8 8 0 0 0 8 0 z "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineBorder);
export default __webpack_public_path__ + "static/media/timeline_border.a485106b7250d3e7f2c7783c5dbf8a31.svg";
export { ForwardRef as ReactComponent };